// File Uploads
export default (form) => {
    const formWrapper = form.closest('.wFormContainer').parentElement;
    const styles = Array.from(formWrapper.querySelectorAll('style, link[rel="stylesheet"]'));
    styles.forEach(el => el.parentElement.removeChild(el));
    formWrapper.classList.add('setup-complete');
};
